// extracted by mini-css-extract-plugin
export default {"item-container":"MealItem_item-container__VWUu9","item-name":"MealItem_item-name__iCdVu","item-price":"MealItem_item-price__ohq2R"};